function openTabFeed(evt, sectionId, tabName) {
  const triggerButton = evt?.currentTarget;
  const parentSection = triggerButton?.closest(".section");

  /* --------------- *** Hide All Tabs *** --------------- */

  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );

  if (!tabcontent.length) return;

  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  /* --------------- *** Deactivate All Tab Buttons *** --------------- */

  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );

  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  /* --------------- *** Show Active Tab *** --------------- */

  const targetTab = document.getElementById(tabName);

  if (!targetTab) return;

  targetTab.style.display = "block";

  if (triggerButton) {
    triggerButton.className += " active";
  }

  /* --------------- *** Restore Arrow Visibility *** --------------- */

  const swiperButtonsContainer = parentSection?.querySelector(".swiper-buttons");

  if (swiperButtonsContainer) {
    swiperButtonsContainer.style.display = "";
  }

  /* --------------- *** Recalculate Slider State *** --------------- */

  const swiperHost = targetTab.querySelector("swiper-component");
  const swiperInstance =
    swiperHost?.swiper ||
    swiperHost?.swiperInstance ||
    swiperHost?.querySelector(".swiper")?.swiper;

  if (swiperInstance) {
    if (typeof swiperInstance.update === "function") {
      swiperInstance.update();
    }

    if (typeof swiperInstance.slideTo === "function") {
      swiperInstance.slideTo(0, 0, false);
    }

    if (swiperInstance.navigation && typeof swiperInstance.navigation.update === "function") {
      swiperInstance.navigation.update();
    }
  }

  /* --------------- *** Update View All Link *** --------------- */

  const viewAllHref = triggerButton?.dataset?.viewAllHref;
  const viewAllButton = parentSection?.querySelector("[data-view-all-button]");

  if (viewAllHref && viewAllButton) {
    viewAllButton.dataset.viewAllHref = viewAllHref;
    viewAllButton.href = viewAllHref;
  } else if (!viewAllHref && viewAllButton) {
    if (viewAllButton.dataset.viewAllHref) {
      viewAllButton.href = viewAllButton.dataset.viewAllHref;
    }
  }

  window.themeSwiper?.notifyLayoutChange?.();
}

function clickDefaultTabs(root = document) {
  root.querySelectorAll("[data-default-open]").forEach((el) => {
    try {
      el.click();
    } catch (error) {
      // Keep initializing other sections even if one tab mapping is invalid.
    }
  });
}

/* --------------- *** Visible Slider Nav Resync *** --------------- */

/**
 * Re-assert navigation state for every visible slider.
 *
 * Multiple feeds/tabs share one set of overlay arrows (.swiper-button--prev/
 * next-{section.id}). Hidden tabs init at zero width, register as "locked", and
 * stomp the shared buttons. Running last, after all sliders init, lets the
 * visible slider take ownership so its arrows reflect its real state.
 */
function resyncVisibleSliderNav() {
  document.querySelectorAll("swiper-component").forEach((host) => {
    if (host.offsetParent === null) return;

    host.swiper?.navigation?.update?.();
  });
}

// show the first tabs by default on load - data-default-open
clickDefaultTabs();

// Resync after init (load) and on resize, where hidden sliders re-stomp the
// shared buttons. Registering resize inside load keeps it after Swiper's own
// resize handling; the rAF coalesces bursts and defers past that handling.
//
// Each section injects this script, so the listener block can run several
// times on a page. Guard it so we attach a single resize handler.
if (!window.__tabManagerResyncInit) {
  window.__tabManagerResyncInit = true;

  window.addEventListener("load", () => {
    let resyncRafId = null;

    const scheduleResync = () => {
      if (resyncRafId !== null) return;

      resyncRafId = requestAnimationFrame(() => {
        resyncRafId = null;
        resyncVisibleSliderNav();
      });
    };

    resyncVisibleSliderNav();
    window.addEventListener("resize", scheduleResync);
  });
}

window.addEventListener("shopify:section:load", () => {
  clickDefaultTabs();
  resyncVisibleSliderNav();
});
